import { createVanIconComponent } from "./van"

const VipCardOutlined = createVanIconComponent("vip-card-o")
export default VipCardOutlined
